export const MIN_COLS = 3;
export const MAX_COLS = 5;
export const COLS_TO_SKIP = 2; // Skip the first (description) and second (Chime) columns

export const INIT_COL_CLASS = 'init';

export const CTA_TYPE_NAME = 'Button';
